module.exports = __webpack_public_path__ + "static/media/6_kontakt.c0d72287.jpg";